import { useCallback, useEffect } from 'react';
import { useAnalytics } from '@hooks/useAnalytics';
import { Router, useRouter } from 'next/router';

const exclude = [
  '/events/[eventId]/devTools',
  '/_error',

  // Tracked manually
  '/events/[eventId]/sessions/[id]',
  '/events/[eventId]/exhibitors/[id]',
  '/events/[eventId]/ondemand',
  '/events/[eventId]/messages',
  '/events/[eventId]/discussions',
  '/events/[eventId]/discussions/[discussionId]/details',
  '/events/[eventId]/pages/[id]',
  '/events/[eventId]/speakers/[id]'
];

/**
 * Track route changes automatically.
 * If additional attributes are required to track add the route to the exclusion list above and trigger the fact manually.
 */
export const useRouterTracking = () => {
  const analytics = useAnalytics();
  const { pathname } = useRouter();

  useEffect(() => {
    // Track path on first load
    if (analytics && pathname && !exclude.includes(pathname)) {
      analytics.track({ path: pathname });
    }
    // Run this once on first load
  }, [analytics]); // eslint-disable-line react-hooks/exhaustive-deps

  const onRouteChange = useCallback(() => {
    if (!exclude.includes(pathname)) {
      analytics.track({ path: pathname });
    }
  }, [pathname, analytics]);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    Router.events?.on('routeChangeComplete', onRouteChange);

    return () => {
      // eslint-disable-next-line no-unused-expressions
      Router.events?.off('routeChangeComplete', onRouteChange);
    };
  }, [onRouteChange]);
};
